import { LoadableLazy } from '@confluence/loadable';

export const CopyWithRovoLoadable = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CopyWithRovo" */ '../src/CopyWithRovo.tsx'))
			.CopyWithRovo,
	loading: () => null,
});
